var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSquareLeftActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.1403 0 0 -1.1403 63.6996 936.3007)",
    id: 858969
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(4,50,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -16.0001)",
    d: "M 12 30.3334 H 20 C 27.24 30.3334 30.3333 27.2401 30.3333 20.0001 V 12.0001 C 30.3333 4.76008 27.24 1.66675 20 1.66675 H 12 C 4.75998 1.66675 1.66665 4.76008 1.66665 12.0001 V 20.0001 C 1.66665 27.2401 4.75998 30.3334 12 30.3334 Z M 20 3.66675 C 26.1466 3.66675 28.3333 5.85341 28.3333 12.0001 V 20.0001 C 28.3333 26.1467 26.1466 28.3334 20 28.3334 H 12 C 5.85331 28.3334 3.66665 26.1467 3.66665 20.0001 V 12.0001 C 3.66665 5.85341 5.85331 3.66675 12 3.66675 H 20 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.6733 0.0016)",
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(4,50,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16.6733, -16.0016)",
    d: "M 14.32 21.7066 C 14.5733 21.7066 14.8266 21.6133 15.0266 21.4133 L 19.7333 16.7066 C 20.12 16.32 20.12 15.68 19.7333 15.2933 L 15.0266 10.5866 C 14.64 10.2 14 10.2 13.6133 10.5866 C 13.2266 10.9733 13.2266 11.6133 13.6133 12 L 17.6133 16 L 13.6133 20 C 13.2266 20.3866 13.2266 21.0266 13.6133 21.4133 C 13.8 21.6133 14.0533 21.7066 14.32 21.7066 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareLeftActive);
export default __webpack_public_path__ + "static/media/arrow-square-left-active.a0dcd80abbd218a758e810bf635746dc.svg";
export { ForwardRef as ReactComponent };